<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__user text-center">
      <img v-if="account" class="mb-3" :src="`data:image/png;base64,${account.image}`" alt="User Image" width="100">
      <img v-else class="mb-3" src="@/assets/user.png" alt="User Image" width="120">
      <div v-if="isAuthenticated">
        <p class="app-sidebar__user-name">{{ user.name }}</p>
        <p class="app-sidebar__user-designation">{{ account.job_position }}</p>
        <p class="app-sidebar__user-designation"><span v-if="account.department">{{ account.department.name }}</span>
        </p>
      </div>
    </div>
    <ul class="app-menu">
      <li>
        <router-link :to="{ name: 'dashboard' }" class="app-menu__item">
          <i class="bi bi-speedometer app-menu__icon"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>
      <div v-if="user && user.role == 'admin'">
        <li>
          <router-link :to="{ name: 'items' }" class="app-menu__item">
            <i class="bi bi-list-ol app-menu__icon"></i>
            <span class="app-menu__label">รายการบริการ</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'services' }" class="app-menu__item">
            <i class="bi bi-ui-checks app-menu__icon"></i>
            <span class="app-menu__label">บริการงานโสตฯ</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Report' }" class="app-menu__item">
            <i class="bi bi-file-earmark-bar-graph app-menu__icon"></i>
            <span class="app-menu__label">รายงาน</span>
          </router-link>
        </li>
      </div>
    </ul>
  </aside>
</template>

<script>
import usersService from '@/services/users-service';
import { mapState } from 'vuex';
export default {
  data() {
    return {
      account: {}
    }
  },
  methods: {
    async getUser(id) {
      try {
        const res = await usersService.get(id)
        this.account = res.data.account
      } catch (error) {
        this.showError(error)
        localStorage.removeItem('vuex')
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapState(['app', 'user'])
  },
  created() {
    this.getUser(this.user.id)
  },

}
</script>

<style scoped>
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>